import { BookingStatus } from '../types';
export function translateBookingStatusToLabel(status, upcoming = false) {
    let label;
    switch (status) {
        case BookingStatus.Pending:
            label = 'Pending';
            break;
        case BookingStatus.Approved:
            label = upcoming ? 'Approved' : 'Taken';
            break;
        case BookingStatus.Rejected:
            label = 'Rejected';
            break;
        case BookingStatus.Cancelled:
            label = 'Cancelled';
            break;
        case BookingStatus.PendingCancellation:
            label = 'Pending cancellation';
            break;
        case BookingStatus.Withdrawn:
            label = 'Withdrawn';
            break;
        default:
            label = '';
            break;
    }
    return label;
}
